import { webview, android, iOS } from 'commons/js/utils/webview';

export default {
  computed: {
    webviewUser() {
      return this.webview(window.navigator.userAgent);
    },
    androidUser() {
      return this.android(window.navigator.userAgent);
    },
    iOSUser() {
      return this.iOS(window.navigator.userAgent);
    },
  },

  methods: {
    webview,
    android,
    iOS,
  }
}
